export const environment = {
  apiUrl: 'https://kano81q8xh.execute-api.us-east-1.amazonaws.com',
  cognito: {
    userPoolId: 'us-east-1_Mo1KQN1ss',
    userPoolClientId: '7783kki47m72rte5chagc0l4gj',
    hostedUiDomain: 'homey-admin-domain-test.auth.us-east-1.amazoncognito.com'
  },
  baseUrl: 'https://admin.test.myhomey.io',
  homeyAppBaseUrl: 'https://test.myhomey.io',
  allowManualNotificationCheck: true,
  allowManualNotificationCheckCustomTime: true,
  allowApplicationUpsert: true,
  allowApplicationStatusEvent: true,
  allowEligibleLotteryEvent: true,
  allowStripeStatusUpdate: true,
  allowNycApplicationOverrides: true,
};
